import styled from 'styled-components';
import { mediaQuery } from '../../../../common/styles/styleUtil';

export const Wrapper = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding-left: 0;

  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const NavigationItemWrapper = styled.li`
  margin-right: clamp(2px, 3%, 32px);
`;
